import styled from 'styled-components';
import UserInitialsImageUploader from '../UserInitialsInputFile';

export const Drawer = styled.div<{ $isOpen: boolean }>`
  padding-top: 32px;
  width: 344px;
  background: ${(props) => props.theme.colors['neutral-0']};
  position: fixed;
  top: 56px;
  right: 0;
  z-index: 9;
  height: calc(100vh - 56px);
  box-shadow: -10px 10px 12px 6px rgba(0, 0, 0, 0.07);
  transition: translate 0.3s ease;
  translate: ${({ $isOpen }) => ($isOpen ? '0px 0px;' : '360px 0px')};
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

export const Scrollable = styled.form`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 0 32px 32px 32px;

  & > div {
    margin-bottom: 16px;
  }
`;

export const HeaderTitle = styled.p`
  color: ${({ theme }) => theme.colors['primary-60']};
  font-size: 18px;
  font-weight: 600;
  line-height: 120%;
`;

export const StyledUserInitials = styled(UserInitialsImageUploader)`
  font-size: 12px;
  margin: 0;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  padding-top: 16px;
`;
